import { apiService } from './apiService';

export const customerService = {
  // Get all customers
  async getCustomers(params?: { status?: string; type?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.type) queryParams.append('type', params.type);
    
    const query = queryParams.toString();
    return await apiService.get(`/customers${query ? `?${query}` : ''}`);
  },

  async getCoordinateAudit() {
    return await apiService.get('/customers/coordinate-audit', { timeoutMs: 600000 });
  },

  async getCoordinateAuditStatus(jobId: string) {
    return await apiService.get(`/customers/coordinate-audit/${jobId}`, { timeoutMs: 600000 });
  },

  // Get customer by ID
  async getCustomer(id: string | number) {
    return await apiService.get(`/customers/${id}`);
  },

  // Create customer
  async createCustomer(data: any) {
    return await apiService.post('/customers', data);
  },

  async bulkImport(rows: any[]) {
    return await apiService.post('/customers/bulk-import', { rows });
  },

  async syncFromShipments() {
    return await apiService.post('/customers/sync-from-shipments', {});
  },

  async deleteGeneratedFromShipments() {
    return await apiService.delete('/customers/generated-from-shipments');
  },

  // Update customer
  async updateCustomer(id: string | number, data: any) {
    return await apiService.put(`/customers/${id}`, data);
  },

  // Delete customer
  async deleteCustomer(id: string | number) {
    return await apiService.delete(`/customers/${id}`);
  },

  // Get customer contracts
  async getContracts(customerId?: string | number) {
    const query = customerId ? `?customerId=${customerId}` : '';
    return await apiService.get(`/contracts${query}`);
  },

  async syncFromStokbar() {
    return await apiService.post('/customers/sync-stokbar', {});
  },

  async transferFromStokbar() {
    return await apiService.post('/customers/transfer-stokbar', {});
  },

  async previewTransferFromStokbar(city?: string) {
    return await apiService.post('/customers/preview-transfer-stokbar', { city });
  },

  async getPreviewTransferFromStokbarStatus(jobId: string) {
    return await apiService.get(`/customers/preview-transfer-stokbar/${jobId}`);
  },

  async importPreviewTransferFromStokbar(rows: any[]) {
    return await apiService.post('/customers/transfer-stokbar', { rows });
  },

  async fetchFromStokbarByCode(code: string) {
    return await apiService.get(`/customers/fetch-stokbar-by-code?code=${encodeURIComponent(code)}`);
  },

  async getStokbarStatus() {
    return await apiService.get('/customers/stokbar-status');
  },

  async getStokbarView(data: { viewType?: 'customer' | 'warehouse' | 'loading'; viewName?: string; kriter?: string }) {
    return await apiService.post('/customers/stokbar-view', data);
  },

  // Get contract by ID
  async getContract(id: string | number) {
    return await apiService.get(`/contracts/${id}`);
  },

  // Create contract
  async createContract(data: any) {
    return await apiService.post('/contracts', data);
  },

  // Update contract
  async updateContract(id: string | number, data: any) {
    return await apiService.put(`/contracts/${id}`, data);
  },
};
